import React from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { get } from 'lodash'

const useStyles = makeStyles((theme) => ({
  root: {
    background: get(theme, 'palette.pageBackground.main'),
  },
}))

interface IPageBackgroundProps {
  className?: string
  [key: string]: any
}

const PageBackground = ({ className, ...rest }: IPageBackgroundProps) => {
  const classes = useStyles()
  return (
    <Box
      className={cn(className, classes.root)}
      minHeight="100vh"
      width="100%"
      bgcolor="pageBackground.main"
      {...rest}
    />
  )
}
export default PageBackground
